import { ExpandedId } from './risk_intelligence.model';

export interface Drawing {
  description: string;
  region_id: string;
  region_name: string;
  date_created: string;
  region_data: GeoJSON.Feature;
}

export interface DrawingData {
  [id: string]: GeoJSON.Feature;
}

export interface DrawingSubmit {
  region_id?: string;
  region_name: string;
  region_data: GeoJSON.Feature;
  description: string;
}

export interface DrawingUpdate extends DrawingSubmit {
  region_id: string;
}

export interface DrawingDelete {
  region_ids: string[];
}

export type DrawingCircleFeature = GeoJSON.Feature<
  GeoJSON.Polygon,
  { isCircle: true; center: number[]; radiusInNm?: number }
>;

export const isDrawingCircleFeature = (
  feature: GeoJSON.Feature
): feature is DrawingCircleFeature =>
  (feature as DrawingCircleFeature)?.properties?.isCircle;

export enum DrawingShape {
  Polygon = 'Polygon',
  Circle = 'Circle',
  Line = 'Line',
  Point = 'Point',
}

export interface CreateDrawingValues {
  common: {
    drawingId?: string; // if drawingId is defined, we're editing an existing drawing
    name: string;
    description: string;
    shape: DrawingShape;
    edited: boolean;
  };
  [DrawingShape.Circle]?: {
    centrePointInputLat: string;
    centrePointInputLong: string;
    radiusInNauticalMilesInput: string;
  };
  [DrawingShape.Polygon]?: {
    coordinates: [string, string][];
  };
  [DrawingShape.Line]?: {
    coordinates: [string, string][];
  };
  [DrawingShape.Point]?: {
    inputLat: string;
    inputLong: string;
  };
}

export type PartialCreateDrawingValues = Partial<{
  common: Partial<CreateDrawingValues['common'] & { shapeId: string }>;
  [DrawingShape.Circle]?: Partial<CreateDrawingValues['Circle']>;
  [DrawingShape.Polygon]?: Partial<CreateDrawingValues['Polygon']>;
  [DrawingShape.Line]?: Partial<CreateDrawingValues['Line']>;
  [DrawingShape.Point]?: Partial<CreateDrawingValues['Point']>;
}>;

export interface DrawingFilters {
  startDate: string | null;
  endDate: string | null;
  ownerTypes: OwnerType[];
  open: boolean;
}

export type OwnerType = ExpandedId;

export enum DrawingType {
  Personal = 'Personal Drawing',
  Company = 'Company Drawing',
}
